export default __webpack_public_path__ + "static/media/our-process-bg-5.f3b511dd.jpg";